import { gainwix_icons } from "api/ApiConfig";

export const images = {
  // home
  About1: `https://storage.googleapis.com/v1-assets-preprod-gainwix/assets/gainwix-images/about1.svg`,
  About2: `https://storage.googleapis.com/v1-assets-preprod-gainwix/assets/gainwix-images/about2.svg`,
  About3: `https://storage.googleapis.com/v1-assets-preprod-gainwix/assets/gainwix-images/about3.svg`,
  WhatsappInactiveBg: `https://storage.googleapis.com/v1-assets-preprod-gainwix/assets/gainwix-images/whatsappInactiveBg.svg`,

  leftLayout: `${gainwix_icons}/assets/gainwix-images/leftLayout.png`,

  BackgroundImage: `${gainwix_icons}/assets/ui/image_1.svg`,
  ContentImage: `${gainwix_icons}/assets/ui/content.svg`,
  WhatsappCsvIcon: `${gainwix_icons}/assets/ui/whastappcsv.svg`,

  // campaign
  NoData: `https://storage.googleapis.com/v1-assets-preprod-gainwix/assets/gainwix-images/no_campaign_data.svg`,
  noCampaign: `${gainwix_icons}/assets/gainwix-images/no-campaign.png`,
  CampaignProspectsIcon: `${gainwix_icons}/assets/gainwix-images/Prospects.svg`,
  CampaignDeliveredIcon: `${gainwix_icons}/assets/gainwix-images/Deliver.svg`,
  CampaignOpenedIcon: `${gainwix_icons}/assets/gainwix-images/Opened.svg`,
  CampaignShareIcon: `${gainwix_icons}/assets/gainwix-images/campaignShare.svg`,
  CampaignSpentIcon: `${gainwix_icons}/assets/gainwix-images/campaignspent.svg`,
  CampaignBackIcon: `${gainwix_icons}/assets/gainwix-images/Back.svg`,

  BroadcastWhatsappImage: `${gainwix_icons}/assets/gainwix-images/whatsapplogo.svg`,
  MessagePreviewIcon: `${gainwix_icons}/assets/gainwix-images/MessagePreview.svg`,
  WhatsappProfileIcon: `${gainwix_icons}/assets/gainwix-images/Profile.svg`,
  BroadcastCsvIcon: `${gainwix_icons}/assets/gainwix-images/download.svg`,

  //brand
  BrandImageIcon: `${gainwix_icons}/assets/gainwix-images/User_1.svg`,
  BrandUserIcon: `${gainwix_icons}/assets/gainwix-images/user2.svg`,
  BrandUser_2Image: `${gainwix_icons}/assets/gainwix-images/user_3.svg`,
  BrandMarketingIcon: `${gainwix_icons}/assets/gainwix-images/Marketing.svg`,
  BrandUtilityIcon: `${gainwix_icons}/assets/gainwix-images/Utility.svg`,
  BrandAuthenticationIcon: `${gainwix_icons}/assets/gainwix-images/Authentication.svg`,
  BrandServiceIcon: `${gainwix_icons}/assets/gainwix-images/Service.svg`,
  BrandCreditIcon: `${gainwix_icons}/assets/gainwix-images/CreditIcon.svg`,
  BrandPlanIcon: `${gainwix_icons}/assets/gainwix-images/FreePlan.svg`,

  // template
  TemplatePreviewBottom: `${gainwix_icons}/assets/gainwix-images/template-preview-bottom.svg`,

  // campaigns
  WhatsApp: `${gainwix_icons}/assets/gainwix-images/whatsapp.svg`,
  Sms: `${gainwix_icons}/assets/gainwix-images/sms.svg`,
  Flag: `${gainwix_icons}/assets/gainwix-images/flag.svg`,
  Broadcast: `${gainwix_icons}/assets/gainwix-images/broadcast.svg`,
  Sequence: `${gainwix_icons}/assets/gainwix-images/sequence.svg`,
  File: `${gainwix_icons}/assets/gainwix-images/file.svg`,

  // contact
  emptyImage: `${gainwix_icons}/assets/gainwix-images/empty.svg`,
  WABANotConnected: `${gainwix_icons}/assets/gainwix-images/WABA_not_connected.svg`,
  WABANotConnected1: `${gainwix_icons}/assets/gainwix-images/WABA_not_connected.png`,

  bg: `${gainwix_icons}/assets/gainwix-images/body-message.png`,
  conversation_bg: `${gainwix_icons}/assets/gainwix-images/conversation_bg.svg`,
  noData: `${gainwix_icons}/assets/gainwix-images/noData.svg`,
};
